var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"helpTextHover",staticClass:"btn btn-transparent p-1 ml-2 nowrap",attrs:{"data-trigger":"hover focus","data-content":_vm.popoverContent,"data-placement":"top","disabled":_vm.disabled},on:{"click":function($event){return _vm.resolve()}}},[_c('span',{staticClass:"icon",class:{
            'icon-glyphicons-basic-check text-primary': !_vm.resolved,
            'icon-glyphicons-basic-circle-empty-check text-success': _vm.resolved
        }})])
}
var staticRenderFns = []

export { render, staticRenderFns }